<!--<div class="responsive-flex-wrapper loader-div">-->
<!--    <span class="spinner"></span>-->
<!--</div>-->

<div id="agaia-loader">
    <div class="loader clear-loader">
        <span>a</span>
        <span>g</span>
        <span>a</span>
        <span>i</span>
        <span>a</span>
    </div>
    <div class="spinner-div">
        <span class="spinner"></span>
    </div>
</div>
